export enum ImageStatus {
  EMPTY,
  SET,
  NEW,
}
